import React from "react";
import ExistingOrderPage from "../components/ExistingOrderPage";

export default function ComplexTenderEditPage() {
  return <ExistingOrderPage mode="edit" />;
}
